import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class EntryExitInvoicing {
  // 进出仓开票列表
  static getEntryExitInvoicingList(options) {
    let url = `/zwy/api/cb/logistics/invoice/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开票记录列表
  static getInvoiceRecordsList(id) {
    const url = `/zwy/api/cb/logistics/invoice/log/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开票详情
  static getInvoiceDetails(id) {
    const url = `/zwy/api/cb/logistics/invoice/get/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 发票账单科目明细列表
  static getInvoiceSubjectDetailsList(id) {
    const url = `/zwy/api/cb/logistics/invoice/order/fee/list/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 生成发票明细
  static postGenerateInvoicing(id, data) {
    const url = `/zwy/api/cb/logistics/invoice/create/invoice/detail/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 保存发票明细
  static postSaveInvoicingDetails(id, data) {
    const url = `/zwy/api/cb/logistics/invoice/update/invoice/detail/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开票
  static postPushInvoicing(id, data) {
    const url = `/zwy/api/cb/logistics/invoice/push/invoice/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 作废
  static postCancelInvoicing(id) {
    const url = `/zwy/api/cb/logistics/invoice/delete/invoice/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 红冲
  static postRedChongInvoicing(id, data) {
    const url = `/zwy/api/cb/logistics/invoice/invalid/invoice/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除发票
  static postDelInvoicing(id) {
    const url = `/zwy/api/cb/logistics/invoice/remove/invoice/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 核销记录列表
  static getWriteOffRecordsList(id) {
    const url = `/zwy/api/cb/logistics/invoice/write/off/log/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 应付核实
  static postVerify(id, data) {
    const url = `/zwy/api/cb/logistics/invoice/check/invoice/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 应付提交
  static postSubmit(id) {
    const url = `/zwy/api/cb/logistics/invoice/commit/invoice/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 拖车明细列表
  static getTrailerList(options) {
    let url = `/zwy/api/cb/logistics/invoice/car/item/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //导入拖车明细
  static postTrailerExcel(data) {
    const url = "/zwy/api/cb/logistics/invoice/upload/car/item";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增拖车明细
  static postAddTrailer(id, data) {
    const url = `/zwy/api/cb/logistics/invoice/save/car/item?invoiceId=${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增拖车明细
  static postDelTrailer(options) {
    let url = `/zwy/api/cb/logistics/invoice/delete/car/item?`;
    url += handleGetRequestParams(options)
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default EntryExitInvoicing;
